import { useEffect, useState } from "react";
import { selector } from "../../../api";
import { gatewayCRUD } from "../../../actions/gateway";
import { TableShared } from "../../../shared";
import { char, number } from "../../../utils";
import { Button, Dropdown, Space, Tooltip } from "antd";
import {
  EyeOutlined,
  DollarOutlined,
  MoreOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import CloseIcon from "@rsuite/icons/Close";
import moment from "moment";
import { Input, InputGroup, Message, Tag, useToaster } from "rsuite";
import { ClearanceData } from "./data";

export const ClearanceContent = () => {
  const [open, setOpen] = useState(false);
  const [printOpen, setPrintOpen] = useState(false);
  const [dataId, setDataId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataInvo, setDataInvo] = useState(null);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [search, setSearch] = useState("");
  const [index, setIndex] = useState(0);

  const toaster = useToaster();

  const user = selector.User();
  const role = selector.Role();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      gatewayCRUD
        .loadUnApprovedClearance()
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {})
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [index]);

  const actionColumn = {
    title: "Action",
    key: "operation",
    fixed: "right",
    width: 70,
    render: (record) => (
      <Dropdown
        menu={{
          items: [
            {
              label: "View",
              key: "view",
              icon: <EyeOutlined />,
            },
          ],
          onClick: (event) => {
            switch (event.key) {
              case "view":
                setOpen(true);
                setDataInvo(record.dtt);
                break;
              default:
            }
          },
        }}
        trigger={["click"]}
        placement="bottomRight"
        arrow={{ pointAtCenter: true }}
      >
        <Space>
          <Button type="dashed" icon={<MoreOutlined />} size="small" />
        </Space>
      </Dropdown>
    ),
  };

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 70,
    },
    {
      key: "payer",
      title: "Payer Name",
      dataIndex: "payer",
      sortable: true,
      width: 300,
    },
    {
      key: "identity",
      title: "Identity No.",
      dataIndex: "identity",
      sortable: true,
      width: 150,
    },
    {
      key: "control_number",
      title: "Control No",
      dataIndex: "control_number",
      sortable: true,
      width: 130,
    },
    {
      key: "refrence",
      title: "Reference No",
      dataIndex: "refrence",
      sortable: true,
      width: 130,
    },
    {
      key: "date",
      title: "Payment Date",
      dataIndex: "date",
      sortable: true,
      width: 130,
    },
    {
      key: "amount",
      title: "Amount",
      dataIndex: "amount",
      sortable: true,
      width: 150,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 150,
    },
  ];

  const columns = [
    ...defaultColumns,
    ...(role.map((item) => item.roleCode).includes("15") ? [actionColumn] : []),
  ];

  const filteredData = data?.filter((item) => {
    const value = search.toLowerCase();

    return (
      item.payer_name.toLowerCase().includes(value) ||
      item.identity_number.toLowerCase().includes(value) ||
      item.control_number.toLowerCase().includes(value) ||
      item.reference.toLowerCase().includes(value)
    );
  });

  const dataItem = filteredData?.map((dt, i) => ({
    id: dt.clearance_id,
    dtt: dt,
    paid: dt.is_paid,
    sn: i + 1,
    post: dt.is_posted,
    payer: dt.payer_name ? char.toUpperCase(dt.payer_name) : "N/A",
    identity: dt.identity_number ? char.toUpperCase(dt.identity_number) : "N/A",
    control_number: dt.control_number ? dt.control_number : "N/A",
    refrence: dt.reference ? char.toUpperCase(dt?.reference) : "N/A",
    date: dt.date ? moment(dt?.date).format("MMM, DD YYYY") : "N/A",
    amount: dt.amount ? (
      <span className="fw-bold">{number.fNumberDoublePoint(dt.amount)}</span>
    ) : (
      "N/A"
    ),
    status: dt.status ? <Tag color="orange">{dt.status}</Tag> : "N/A",
  }));

  console.log();

  const filter = (
    <>
      <div className="col-md-3 col-sm-12">
        <InputGroup inside style={{ width: 300 }}>
          <Input
            placeholder="Search....."
            size="lg"
            value={search}
            onChange={(e) => setSearch(char.toLowerCase(e))}
          />
          {search && (
            <InputGroup.Button
              size="lg"
              onClick={() => {
                setSearch("");
              }}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
      </div>
    </>
  );

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2" style={{ marginTop: -30 }}>
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Invoice Clearance</p>
          </div>
          <hr />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={null}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={columns}
          button={null}
          link={"#"}
          showButton={true}
          search={filter}
          showSearch={true}
          setLoading={setLoading}
        />
      </div>
      <ClearanceData
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
        data={dataInvo}
      />
    </>
  );
};
